import notificationService from "src/services/orderNotificationService";

export const SEARCH_NOTIFICATION_RULES_REQUEST =
  "@notification/search-notification-rules-request";
export const SEARCH_NOTIFICATION_RULES_SUCCESS =
  "@notification/search-notification-rules-success";
export const SEARCH_NOTIFICATION_RULES_FAILURE =
  "@notification/search-notification-rules-failure";

export const GET_LIST_NOTIFICATIONS_RULE_REQUEST =
  "@notification/get-list-notifications-rule-request";
export const GET_LIST_NOTIFICATIONS_RULE_SUCCESS =
  "@notification/get-list-notifications-rule-success";
export const GET_LIST_NOTIFICATIONS_RULE_FAILURE =
  "@notification/get-list-notifications-rule-failure";

export const GET_ONE_NOTIFICATION_REQUEST = "@notification/get_one-notification-request";
export const GET_ONE_NOTIFICATION_SUCCESS = "@notification/get_one-notification-success";
export const GET_ONE_NOTIFICATION_FAILURE = "@notification/get_one-notification-failure";

export const UPDATE_NOTIFICATION_REQUEST = "@notification/update-notification-request";
export const UPDATE_NOTIFICATION_SUCCESS = "@notification/update-notification-success";
export const UPDATE_NOTIFICATION_FAILURE = "@notification/update-notification-failure";

export const CREATE_NOTIFICATION_REQUEST = "@notification/create-notification-request";
export const CREATE_NOTIFICATION_SUCCESS = "@notification/create-notification-success";
export const CREATE_NOTIFICATION_FAILURE = "@notification/create-notification-failure";

export const UPDATE_ACTIVE_COMMENT_REQUEST =
  "@notification/update-active-notification-request";
export const UPDATE_ACTIVE_COMMENT_SUCCESS =
  "@notification/update-active-notification-success";
export const UPDATE_ACTIVE_COMMENT_FAILURE =
  "@notification/update-active-notification-failure";

export const DELETE_NOTIFICATION_REQUEST = "@notification/delete-notification-request";
export const DELETE_NOTIFICATION_SUCCESS = "@notification/delete-notification-success";
export const DELETE_NOTIFICATION_FAILURE = "@notification/delete-notification-failure";

export const GET_LIST_STATE_REQUEST = "@customer/get-list-state-request";
export const GET_LIST_STATE_SUCCESS = "@customer/get-list-state-success";
export const GET_LIST_STATE_FAILURE = "@customer/get-list-state-failure";

export const GET_LIST_PAYMENT_METHOD_REQUEST =
  "@customer/get-list-payment-method-state-request";
export const GET_LIST_PAYMENT_METHOD_SUCCESS =
  "@customer/get-list-payment-method-success";
export const GET_LIST_PAYMENT_METHOD_FAILURE =
  "@customer/get-list-payment-method-failure";

export function searchNotificationRules(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: SEARCH_NOTIFICATION_RULES_REQUEST});
      const response = await notificationService.searchNotificationRules(data);
      dispatch({
        type: SEARCH_NOTIFICATION_RULES_SUCCESS,
        payload: {
          response: response.data.data,
          total: +response?.headers["x-total-items"] || 0
        }
      });
    } catch (error) {
      dispatch({type: SEARCH_NOTIFICATION_RULES_FAILURE});
      throw error;
    }
  };
}

export function getListNotificationRules() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_NOTIFICATIONS_RULE_REQUEST});
      const response = await notificationService.getListNotificationRules();
      dispatch({
        type: GET_LIST_NOTIFICATIONS_RULE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_NOTIFICATIONS_RULE_FAILURE});
      throw error;
    }
  };
}

export function getOneNotification(data) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ONE_NOTIFICATION_REQUEST});
      const response = await notificationService.getOneNotification(data);
      dispatch({
        type: GET_ONE_NOTIFICATION_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ONE_NOTIFICATION_FAILURE});
      throw error;
    }
  };
}

export function updateNotification(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_NOTIFICATION_REQUEST});
      const response = await notificationService.updateNotification(data);
      dispatch({
        type: UPDATE_NOTIFICATION_SUCCESS,

        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_NOTIFICATION_FAILURE});
      throw error;
    }
  };
}
export function createNotification(data) {
  return async (dispatch) => {
    try {
      dispatch({type: CREATE_NOTIFICATION_REQUEST});
      const response = await notificationService.createNotification(data);
      dispatch({
        type: CREATE_NOTIFICATION_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: CREATE_NOTIFICATION_FAILURE});
      throw error;
    }
  };
}

export function deleteNotification(data) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_NOTIFICATION_REQUEST});
      const response = await notificationService.deleteNotification(data);
      dispatch({
        type: DELETE_NOTIFICATION_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: DELETE_NOTIFICATION_FAILURE});
      throw error;
    }
  };
}
export function getListState() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_STATE_REQUEST});
      const response = await notificationService.getListState();
      dispatch({
        type: GET_LIST_STATE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_STATE_FAILURE});
      throw error;
    }
  };
}
export function getListPaymentMethod() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_PAYMENT_METHOD_REQUEST});
      const response = await notificationService.getListPaymentMethod();
      dispatch({
        type: GET_LIST_PAYMENT_METHOD_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_PAYMENT_METHOD_FAILURE});
      throw error;
    }
  };
}
